import { applyMiddleware, createStore, AnyAction } from 'redux';
import thunkMiddleware, { ThunkMiddleware } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reducer } from './reducer';

export function configureStore(initialState = {}) {
    const thunk: ThunkMiddleware<any, AnyAction> = thunkMiddleware;
    const middlewares = applyMiddleware(thunk);
    const store = createStore(reducer, initialState, composeWithDevTools(middlewares));

    return store;
}
